import React from 'react';
import LocationInMap from '../Components/Map/LocationInMap';
import Hero16 from '../Components/Hero/Hero16';
import ServiceSlider from '../Components/Slider/ServiceSlider';
import Appointment2 from '../Components/Appointment/Appointment2';
import TestimonialSlider2 from '../Components/Slider/TestimonialSlider2';
import Contact2 from '../Components/Contact/Contact2';
import About5 from '../Components/About/About5';

const heroData = {
  bgImg: '/images/dental/hero-img4.jpg',
  heading: `Nous fournissons <br />  des services dentaires <br />  de haute qualité`,
  title: ['Blanchiment', 'Prothése','Esthétique dentaire', "Parodontologie", "Dentisterie pédiatrique","Soins", "Chirurgie", "Implantologie" ],
};

const aboutData = {
  title:`Nous fournissons un service <span className="st-light-blue"> dentaire </span> de haute qualité avec médecin expatrié.`,
  subTitle: `Nous proposons également des traitements qui améliorent l’apparence de votre sourire, vous donnant ainsi le regain de confiance que vous méritez. Le processus ou notre traitement ci-dessous.`,
  list: [
    {
      text: 'Blanchiment',
    },
    {
      text: 'Prothése',
    },
    {
      text: 'Esthétique dentaire',
    },
    {
      text: 'Parodontologie',
    },
    {
      text: 'Dentisterie pédiatrique',
    },
    {
      text: 'Chirurgie',
    },
    {
      text: 'Soins',
    },
    {
      text: 'Implantologie',
    },
  ],
  beforeImg: `images/dental/after1.jpg`,
  afterImg: `images/dental/before1.jpg`,
};

const certificateData = {
  certificate: [
    { imgSrc: 'images/dental/certificate1.jpg' },
    { imgSrc: 'images/dental/certificate2.jpg' },
    { imgSrc: 'images/dental/certificate3.jpg' },
    { imgSrc: 'images/dental/certificate4.jpg' },
    { imgSrc: 'images/dental/certificate5.jpg' },
    { imgSrc: 'images/dental/certificate1.jpg' },
    { imgSrc: 'images/dental/certificate2.jpg' },
    { imgSrc: 'images/dental/certificate3.jpg' },
    { imgSrc: 'images/dental/certificate4.jpg' },
    { imgSrc: 'images/dental/certificate5.jpg' },
  ],
};

const serviceData = {
  sectionHeadingData: {
    subTitle: `Nos Services`,
    title: `Découvrez une gamme complète de services dentaires adaptés à vos besoins. Que ce soit pour des soins préventifs, des traitements esthétiques, des restaurations ou des interventions chirurgicales.`,
  },
  services: [
    {
      img: 'images/dental/service1.jpg',
      title: 'Traitement de Canal Radiculaire',
      text: 'Le traitement de canal radiculaire soulage efficacement la douleur dentaire en nettoyant et en scellant les racines infectées, préservant ainsi votre dent naturelle et restaurant votre confort buccal',
    },
    {
      img: 'images/dental/service2.jpg',
      title: 'Alignement des Dents',
      text: 'L’alignement des dents améliore votre sourire et votre confort en corrigeant les malpositions dentaires grâce à des solutions comme les appareils orthodontiques ou les aligneurs transparents, pour des résultats durables et esthétiques.',
    },
    {
      img: 'images/dental/service3.jpg',
      title: 'Implants Dentaires',
      text: 'Les implants dentaires remplacent les dents manquantes avec des solutions durables et naturelles. Ils restaurent votre sourire, améliorent votre mastication et offrent un confort optimal grâce à une intégration parfaite à votre mâchoire.',
    },
    {
      img: 'images/dental/service1.jpg',
      title: 'Blanchiment dentaire',
      text: 'Le blanchiment dentaire illumine votre sourire en éliminant les taches et les décolorations. Offrez-vous des dents éclatantes grâce à des traitements sûrs et efficaces réalisés par nos experts',
    },
    {
      img: 'images/dental/service2.jpg',
      title: 'Chirurgie dentaire',
      text: 'La chirurgie dentaire traite des affections complexes telles que les dents de sagesse, les infections ou les lésions buccales. Nos chirurgiens qualifiés assurent des soins précis et sécurisés pour votre santé bucco-dentaire.',
    },
    {
      img: 'images/dental/service3.jpg',
      title: 'Dental Implants',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore.',
    },
  ],
};

const appointmentData = {
  title:`Prendre <span className="st-light-blue"> rendez-vous </span> Nous accueillons toujours de nouveaux patients`,
  img: `/images/dental/appointment.png`,
  phone: `0663044661`,
  landlinePhone:`0522030330`
};

const testimonialData = {
  sectionHeadingData: {
    subTitle: `Testimonial`,
    title: "Ce que nos clients disent de nous"
  },
  testimonials: [
    {
      img: 'images/avatar2.png',
      name: 'Elamrani Elhabib',
      designation: 'Executive',
      subTitle:"Je suis très satisfait des services du centre dentaire Alyousr Berrechid L'équipe est professionnelle,  et compétente. Les installations sont modernes et propres, ce qui crée une atmosphère accueillante. Mes visites sont toujours"
    },
    {
      img: 'images/avatar3.png',
      name: 'halima elkanbi',
      designation: 'Biographer',
      subTitle:
        "Merci infiniment d'avoir améliorer ma vie et merci infiniment pour votre service et votre écoute, et merci pour m'avoir libérer de  la phobie  bonne chance et bonnecontinuation à vous chère docteur",
    },
    {
      img: 'images/avatar4.png',
      name: 'Azziz El Akkaoui',
      designation: 'UX Designer',
      subTitle:
        "Docteur compétente et serviable. son cabinet est très propre, ses rendez-vous sont très bien respectés, Je vous la conseille fortement.",
    },
    {
      img: 'images/avatar2.png',
      name: 'Zaineb Majdi',
      designation: 'Executive',
      subTitle:
        "Elle est professionnelle ,fiable et compétente. Je vous remercier ma chérie de tout ce que tu as fait avec ma mère. c'est hyper gentil, doux et génial de ta part .Le  top du top, bonne continuation.",
    },
    {
      img: 'images/avatar3.png',
      name: 'Asma Rida',
      designation: 'Biographer',
      subTitle:
        "Je recommande vivement Dr Elhitary siham pour son professionnalisme, sec compétences confirmées  et surtout ses qualités d'écoute et de suivie. Hamdolilah, j'étais entre les bonnes mains.  BONNE CONTINUATION.",
    },
    {
      img: 'images/avatar4.png',
      name: 'Boumalik Soukaina',
      designation: 'UX Designer',
      subTitle:"Je recommande vivement",
    },
  ],
};

const videoBlock = {
  sectionHeadingData: {
    subTitle: `Testimonial`,
    title: `Here are some <br/> sample <span class="st-light-blue">videos</span> about our work`,
  },
  imgSrc: 'images/dental/video.jpg',
  videoSrc: 'https://www.youtube.com/embed/l2uQyBCmj9I?autoplay=1',
};




const contactData = {
  sectionHeadingData: {
    subTitle: `Nous savons que choisir les bons soins dentaires est essentiel. Si vous avez des doutes ou souhaitez plus de détails sur nos traitements, envoyez-nous un message—nous serons ravis de vous aider !`,
    title: ` Besoin de Plus d’Informations Avant de   <span class="st-light-blue">Prendre RDV</span>`,
  },
};



const mapLocationURL ='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3336.185410362803!2d-7.5797899!3d33.26163799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda63d46971d8dfd%3A0x856e220fda988857!2sCENTRE%20DENTAIRE%20Al%20YOUSR%20Dr.Elhitary%20Siham%20parodontologie%20dentisterie%20esth%C3%A9tique%20blanchiment%20implant%20proth%C3%A8se%20soins%20chirurgie%20orale!5e0!3m2!1sen!2sma!4v1740792919767!5m2!1sen!2sma';

const Home16 = () => {
  return (
    <div>
      <Hero16 data={heroData} />
      <About5 data={aboutData} />
      <ServiceSlider data={serviceData} varient="st-type1" />
      <Appointment2 data={appointmentData} />
      <TestimonialSlider2 data={testimonialData} varient="st-type1" />
      <Contact2 data={contactData} varient="st-gray-bg2" />
      <LocationInMap data={mapLocationURL} />
    </div>
  );
};

export default Home16;
